/**
 * Monaco Editor setup.
 * Configures @monaco-editor/react to load Monaco from a pinned CDN version.
 * This avoids bundling the massive monaco-editor package locally (which
 * causes OOM during production builds).
 *
 * Import this module (side-effect) before rendering any <Editor /> component.
 */
import { loader } from "@monaco-editor/react";

loader.config({
  paths: {
    vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.55.0/min/vs",
  },
});

/**
 * Helper: returns the monaco namespace once the loader has finished.
 * Use this when you need monaco APIs (e.g. monaco.Range) without a
 * static import of the giant monaco-editor package.
 */
export const getMonaco = () => loader.init();
